module.exports = __webpack_public_path__ + "img/ia-01-8.1e48b51e.jpg";